// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1xb25","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__opY63"};